import React, { useState } from "react";
import { Send } from "lucide-react";

export default function CommentsSection() {
  const [comments, setComments] = useState([
    {
      id: 1,
      author: "Ramesh Singh",
      initials: "RS",
      message: "Critical rejection. Bureau score is below minimum threshold.",
      timestamp: "Apr 24,2024 at 1:00pm",
    },
    {
      id: 2,
      author: "Ramesh Singh",
      initials: "RS",
      message: "Critical rejection. Bureau score is below minimum threshold.",
      timestamp: "Apr 24,2024 at 1:00pm",
    },
    {
      id: 3,
      author: "Ramesh Singh",
      initials: "RS",
      message: "Critical rejection. Bureau score is below minimum threshold.",
      timestamp: "Apr 24,2024 at 1:00pm",
    },
  ]);

  const [newComment, setNewComment] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newComment.trim()) {
      setComments([
        ...comments,
        {
          id: comments.length + 1,
          author: "You",
          initials: "Y",
          message: newComment,
          timestamp: new Date().toLocaleString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            meridiem: "short",
          }),
        },
      ]);
      setNewComment("");
    }
  };

  return (
    <div
      style={{
        minHeight: "400px",
        background: "#fff",
        borderRadius: "10px",
        padding: "20px",
        border: "1px solid #e0e0e0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        position: "relative",

        animation: "slideInLeft 0.55s cubic-bezier(0.16, 1, 0.3, 1) both",
      }}
    >
      <style>{`
        @keyframes slideInLeft {
          0%   { opacity: 0; transform: translateX(-48px) scale(0.95) translateY(6px); filter: blur(3px); }
          60%  { opacity: 1; filter: blur(0px); }
          100% { opacity: 1; transform: translateX(0) scale(1) translateY(0); filter: blur(0px); }
        }
      `}</style>
      {/* Connection dot */}
      <div
        style={{
          position: "absolute",
          right: "-6px",
          top: "calc(50% - 20px)",
          transform: "translateY(-50%)",
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: "white",
          border: "4px solid #a0aab4",
          zIndex: 1,
        }}
      />

      {/* Title */}
      <h2
        style={{
          fontSize: "20px",
          fontWeight: "bold",
          color: "#1e293b",
          marginBottom: "24px",
        }}
      >
        Comments
      </h2>

      {/* Comments List */}
      <div style={{ marginBottom: "24px" }}>
        {comments.map((comment) => (
          <div
            key={comment.id}
            style={{ display: "flex", gap: "16px", marginBottom: "24px" }}
          >
            {/* Avatar */}
            <div style={{ flexShrink: 0 }}>
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(to bottom right, #06b6d4, #0891b2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  {comment.initials}
                </span>
              </div>
            </div>

            {/* Content */}
            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "4px",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#06b6d4",
                    cursor: "pointer",
                  }}
                >
                  {comment.author}
                </span>
                <span style={{ fontSize: "12px", color: "#64748b" }}>
                  {comment.timestamp}
                </span>
              </div>
              <p style={{ color: "#475569", lineHeight: "1.6", margin: 0 }}>
                {comment.message}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Input Area */}
      <form onSubmit={handleSubmit} style={{ display: "flex", gap: "12px" }}>
        <input
          type="text"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Add a comment..."
          style={{
            flex: 1,
            padding: "12px 16px",
            borderRadius: "8px",
            border: "1px solid #cbd5e1",
            background: "#fff",
            color: "#1e293b",
            fontSize: "14px",
            outline: "none",
            transition: "all 0.2s ease",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#3b82f6";
            e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#cbd5e1";
            e.target.style.boxShadow = "none";
          }}
        />
        <button
          type="submit"
          style={{
            background: "#3b82f6",
            color: "white",
            borderRadius: "8px",
            padding: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            cursor: "pointer",
            transition: "all 0.2s ease",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#2563eb";
            e.target.style.boxShadow = "0 4px 6px rgba(0,0,0,0.1)";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#3b82f6";
            e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
          }}
        >
          <Send size={20} strokeWidth={2.5} />
        </button>
      </form>
    </div>
  );
}
